import React, {FC} from 'react'
import Popup from '@rambler-components/popup'
import Geo from '@rambler-components/geo'
import '@rambler-components/geo/styles.css'
import '@rambler-components/popup/styles.css'
import styles from './styles.css'
import {useViewport} from '@rambler-id/react'

export interface Props {
  geoOpened: boolean
  onChange: () => void
  onClose: () => void
}

export const GeoPopup: FC<Props> = ({geoOpened, onChange, onClose}) => {
  const {isMobile} = useViewport()

  return (
    <Popup
      width={560}
      isOpen={geoOpened}
      onClose={onClose}
      isFullPage={isMobile}
      focusRecovery={false}
      className={styles.root}>
      <Geo onChange={onChange} onClose={onClose} />
    </Popup>
  )
}
